/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cover_Letters_Tone_FormalInputs */

const en_cover_letters_tone_formal = /** @type {(inputs: Cover_Letters_Tone_FormalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Formal`)
};

const de_cover_letters_tone_formal = /** @type {(inputs: Cover_Letters_Tone_FormalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Formell`)
};

const fr_cover_letters_tone_formal = /** @type {(inputs: Cover_Letters_Tone_FormalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Formel`)
};

const es_cover_letters_tone_formal = /** @type {(inputs: Cover_Letters_Tone_FormalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Formal`)
};

const it_cover_letters_tone_formal = /** @type {(inputs: Cover_Letters_Tone_FormalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Formale`)
};

const nl_cover_letters_tone_formal = /** @type {(inputs: Cover_Letters_Tone_FormalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Formeel`)
};

const pl_cover_letters_tone_formal = /** @type {(inputs: Cover_Letters_Tone_FormalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Formalny`)
};

const fi_cover_letters_tone_formal = /** @type {(inputs: Cover_Letters_Tone_FormalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Virallinen`)
};

const da_cover_letters_tone_formal = /** @type {(inputs: Cover_Letters_Tone_FormalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Formel`)
};

const sv_cover_letters_tone_formal = /** @type {(inputs: Cover_Letters_Tone_FormalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Formell`)
};

/**
* | output |
* | --- |
* | "Formal" |
*
* @param {Cover_Letters_Tone_FormalInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const cover_letters_tone_formal = /** @type {((inputs?: Cover_Letters_Tone_FormalInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cover_Letters_Tone_FormalInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_cover_letters_tone_formal(inputs)
	if (locale === "fr") return fr_cover_letters_tone_formal(inputs)
	if (locale === "es") return es_cover_letters_tone_formal(inputs)
	if (locale === "it") return it_cover_letters_tone_formal(inputs)
	if (locale === "nl") return nl_cover_letters_tone_formal(inputs)
	if (locale === "pl") return pl_cover_letters_tone_formal(inputs)
	if (locale === "fi") return fi_cover_letters_tone_formal(inputs)
	if (locale === "da") return da_cover_letters_tone_formal(inputs)
	if (locale === "sv") return sv_cover_letters_tone_formal(inputs)
	return en_cover_letters_tone_formal(inputs)
});